import { Color, Kind } from '@usitsdasdesign/dds-react';
import { yupValidator } from 'lib/yup-validator';
import Dialog from 'molecules/Dialog';
import RenderFields from 'molecules/RenderFields';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

function UnAllocate({
    show = false,
    onClose,
    onSave, isMulti = false
}) {
    if (!show) return null;
    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        formState: { errors }
    } = useForm({
        resolver: yupValidator(
            yup.object().shape({
                unallocateReason: yup.string()
            }),
        ),
        defaultValues: {
        }
    });
    const fields = [
        {
            id: 3,
            type: 'text-input',
            name: 'unallocateReason',
            label: 'Reason for unallocation',
            placeholder: 'Enter reason for unallocation',
            isDisabled: false,
            isRequired: false,
            className: 'md:col-span-2 md:max-w-[100%]'
        }
    ];

    return (
        <Dialog
            title='Unallocate Employee'
            show={true}
            onClose={onClose}
            size='md'
            actions={[
                {
                    label: 'Close',
                    kind: Kind.secondaryLoud,
                    color: Color.green,
                    isDisabled: false,
                    onClick: onClose
                },
                {
                    label: 'Submit',
                    kind: Kind.primaryLoud,
                    color: Color.green,
                    isDisabled: false,
                    onClick: handleSubmit(onSave)
                }
            ]}
        >
            <RenderFields
                fields={fields}
                control={control}
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                grid='grid-cols-1'
            />
       </Dialog>
    );
}

export default UnAllocate;
